import type { OfferSubCategory } from '../../../common/enums.js';

export const normalizeProductSubcategory = (subcategory?: string): string => subcategory?.toLowerCase() ?? '';

export const isProductSubcategory = (subcategory: string | undefined, expected: OfferSubCategory): boolean =>
  normalizeProductSubcategory(subcategory) === normalizeProductSubcategory(expected);
